import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';

import { Editor } from 'libs/editor';
import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';

import { clientStore } from 'apps/client/app';

import {
  Main,
  CategoryWrapper,
  BackLink,
  Name,
  Color,
  Description,
  ButtonStyled,
} from 'apps/forum/views/intro.styles';

export const Intro = withNamespaces()(props => {
  const {
    description,
    categoryName,
    categoryColor,
    categoryUrlId,
    buttonHandler,
  } = props;

  const builderCategory = () => {
    const initiativeParams = Object.assign({}, clientStore.spaceParams);
    const categoryParams = Object.assign({}, clientStore.spaceParams, {
      categoryId: categoryUrlId,
    });

    return (
      <CategoryWrapper>
        <Name>
          <BackLink name='initiative.forum' params={initiativeParams}>
            <Trans>All Categories</Trans>
          </BackLink>
        </Name>
        <Name light>&nbsp;&#8250;&nbsp;</Name>
        {categoryUrlId ? (
          <>
            <Link name='initiative.forum.category' params={categoryParams}>
              <Name isLink color={categoryColor}>
                <Color color={categoryColor}>
                  <Trans>{categoryName}</Trans>
                </Color>
              </Name>
            </Link>
            <Name light>&nbsp;&#8250;&nbsp;</Name>
          </>
        ) : (
          <Name>
            <Color color={categoryColor}>
              <Trans>{categoryName}</Trans>
            </Color>
          </Name>
        )}
      </CategoryWrapper>
    );
  };
  const Category = categoryName && builderCategory();

  const builderDescriptionEditor = () => {
    const store = new EditorStore({
      initialValue: html.deserialize(description),
      formatting: 'basic',
    });
    return (
      <Description>
        <Editor store={store} />
      </Description>
    );
  };
  const DescriptionEditor = description && builderDescriptionEditor();

  return (
    <Main noBorder={categoryUrlId}>
      {Category}
      {DescriptionEditor}
      {buttonHandler && (
        <ButtonStyled
          text={<Trans>New Thread</Trans>}
          size='small'
          onClick={buttonHandler}
          icon='add'
        />
      )}
    </Main>
  );
});

Intro.propTypes = {
  description: PropTypes.string,
  categoryName: PropTypes.string,
  categoryColor: PropTypes.string,
  categoryUrlId: PropTypes.string,
  buttonHandler: PropTypes.func,
};
